import {
  V2ListTextBlocksForAccountApiArg,
  useV2ListTextBlocksForAccountQuery,
} from "@generated";
import type { TextBlock } from "../types";

export interface UseTextBlocksListArgs {
  page?: V2ListTextBlocksForAccountApiArg["page"];
  sort?: V2ListTextBlocksForAccountApiArg["sort"];
}

export interface TextBlocksListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useTextBlocksList = ({ page, sort }: UseTextBlocksListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListTextBlocksForAccountQuery(
      { page, sort },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: TextBlock[] = (data?.data ?? []).map((tb) => ({
    id: String(tb.id),
    name: tb.attributes?.name ?? "",
    slug: tb.attributes?.slug ?? "",
  }));

  const pageMeta: TextBlocksListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useTextBlocksList;
